export default __webpack_public_path__ + "navigation-examples-custom-segue-thumbnail-960-9ee3257b04f26e03843439f2a64f3501.png";